<template>
    <div v-if="estates.length > 0" class="tecnomap-estates">
        <!-- :per-page-custom="[[0, 1], [768, 2], [991, 2], [1100, 3], [1200, 4]]" -->
        <my-carousel 
            :per-page="1"
            :pagination-enabled="true"
            :navigation-enabled="false"
            :min-swipe-distance="2"
            :show-title="true"
        >
            <template v-for="estate in estates">
                <slide :key="estate.id" :title="estate.title">
                    <div class="tecnomap-estate-card">
                        <estate-card :estate="estate" :extLang="extLang" :showActions="showActions" />
                    </div>
                </slide>
            </template>
        </my-carousel>
    </div>
</template>

<script>
import MyCarousel from '../MyCarousel'
import EstateCard from './Card'

export default {
    components: {
        'my-carousel': MyCarousel,
        'estate-card': EstateCard,
    },

    props: {
        estates: {
            type: Array,
            required: false,
        },

        extLang: {
            type: Object
        },

        showActions: {
            type: Boolean,
            default: true,
        },
    },
}
</script>